import { Units } from "../constants/Unit";

export const validateEmail=(email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const validationEmail=email => {
  return validateEmail(email)? true: false;
}

export const validationDigit=email => {
  if (validatedigit(email)) {
    return true
  }
  alert("The password should be minimum of 6-digits!");
  return false;
}

export const exchangeElements = (data, index) => {
  var ret = [];
  if( index === 0 )
    ret = [data[1], data[0], data[2]];
  else if( index === 1 )
    ret = data;
  else if( index === 2)
    ret = [data[0], data[2], data[1]];
  return ret;
}

export const validatedigit=(inputtxt)=>{
  var phoneno = /^\d{6}$/;
  if( phoneno.test(String(inputtxt).toLowerCase())){
    return true;
  } else {
    return false;
  }
}

export const validateNumber=(inputtxt)=>{
  var phoneno = /^\d{11}$/;
  if(phoneno.test(String(inputtxt).toLowerCase())){
    return true;
  } else {
    alert("Phone number is incorrect!");
    return false;
  }
}

export function formatNumberWithCommas(n) {
  if (n == null || typeof n !== "number") return "0";
  return n.toLocaleString();
}

export const shuffle = (array) => {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export const getRenderDataForPracticeResult = (ques, section, lid) => {
  // return new Promise ((resolve, reject) => {
    let retData = [];
    const rules = Units.ruleForSelecting[`level${lid}`];
    const secCnt = [rules["section1"], rules["section2"], rules["section3"], rules["section4"], rules["section5"], rules["section6"], rules["section7"], rules["section8"], rules["section9"], rules["section10"]];
  
    let t=[0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let total = 0;
    let tpCnt = 0;
    ques.forEach(quesitem => {
      tpCnt++;
      if( quesitem.Correctanswer === quesitem.userAnswer || quesitem.CorrectAnswer === quesitem.userAnswer  ){
        total++;
        if( quesitem.SectionId === section[0].SectionId){
          t[0]++;
        }
        if( quesitem.SectionId === section[1].SectionId ){
            t[1]++;
        }
        if( quesitem.SectionId === section[2].SectionId ){
            t[2]++;
        }
        if( quesitem.SectionId === section[3].SectionId ){
            t[3]++;
        }
        if( quesitem.SectionId === section[4].SectionId ){
            t[4]++;
        }
        if( quesitem.SectionId === section[5].SectionId ){
            t[5]++;
        }
        if( quesitem.SectionId === section[6].SectionId ){
            t[6]++;
        }
        if( quesitem.SectionId === section[7].SectionId ){
            t[7]++;
        }
        if( quesitem.SectionId === section[8].SectionId ){
            t[8]++;
        }
        if( quesitem.SectionId === section[9].SectionId ){
            t[9]++;
        }
      }      
    });
    if( tpCnt === ques.length ){
      let count = 0;
      t.forEach((cnt, index) => {
        retData.push({
          name: "Lesson " + (count+1),
          totalCnt: secCnt[count],
          correctCnt: cnt,
          percent: parseInt(100 * cnt / secCnt[count]),
        });
        count++;
      });
      return {
        total: total,
        data: retData,
      };
    }
  // })
}

const strMonths = ["Jan", "Feb", "Mar", "Apl", "May", "Jun", "Jly", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const getCurrentDayTime = () => {
  var date = new Date();
  var day = date.getDate();
  var mon = strMonths[date.getMonth()];
  var y = date.getFullYear();
  var h = date.getHours();
  var m = date.getMinutes();
  return mon + " " + day + ", " + y + " " + h + ":" + m + formatAMPM(date);
}

export const formatAMPM = (date) => {
  var hours = date.getHours();
  var ampm = hours>=12 ? 'pm' : 'am';
  return ampm;
}

export const getAveScore = (arr) => {
  if( arr === null ) return 0;
  if( arr.length === 0 ) return 0;
  const division = arr.length > 3 ? 3: arr.length;
  let score = 0;
  for( let i = 0 ; i < 3 ; i++ ){
    if( i < arr.length )
      score += arr[i].Score;
  }

  return parseInt(score/division);
}

export const getPassedCnt = (arr) => {
  if( arr === null ) return 0;
  if( arr.length === 0 ) return 0;
  const temp = arr.filter((_) => _.Pass === 1);
  return temp.length;
}

export function getAverageOfArrayWithParameter(array, parameter) {
  let sum = null;
  if (array && array.length > 0 && typeof parameter === 'string') {
    sum = 0;
    for (let e of array) if (e && e.hasOwnProperty(parameter)) sum += e[parameter];
  }
  return sum / array.length;
}